<template>
    <div class="jump-login nav-bar-fixed">
        <van-nav-bar title="忘记密码" left-arrow fixed 
        @click-left="back" />
        <div class="jump-login-logo" >
                <img src="../assets/logo.png" />
        </div>
        <div class="jump-login-body">
            <van-cell-group>
                <van-field 
                    v-model="phone" 
                    placeholder="请输入手机号码"
                    >
                  <i class="iconfont icon-icon--" slot="left-icon"></i>
                </van-field>
                <van-field
                    v-model="smsCode"
                    placeholder="请输入短信验证码"
                    >
                  <i class="iconfont icon-mima" slot="left-icon"></i>
                    <van-button :disabled="smsBtnDisabled"  slot="button" size="small" type="primary" class="smsBtn" @click="sendCode">
                     {{smsBtnText}}
                      </van-button>
                </van-field>
                <van-field
                    v-model="password"
                    type="password"
                    placeholder="请输入密码"
                    >
                  <i class="iconfont icon-mima" slot="left-icon"></i>
                </van-field>
            </van-cell-group>
            <div class="jump-login-body-foo">
                <van-button  size="large" @click="changePwd">确 认</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { NavBar,Cell, CellGroup, Field, Button, Row, Col,Switch  } from "vant";
export default {
  name: "repass",
  components: {
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]:Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Switch.name]:Switch 
  },
  data() {
    return {
      phone: "",
      password: "",
      smsCode: "",
      smsBtnDisabled:false,
      smsBtnText:'获取验证码'
    };
  },
  methods: {
    back(){
      history.back();
    },
    sendCode(){
      let that = this;
       if(this.phone == ""){
        this.$toast('请填写手机号');
      }else{
        this.$api.get(that.jumuc.user.findPwdSms,{'mobile':that.phone},
        successRes=>{
          that.$toast(successRes.msg);
          if(successRes.success){
            //发送成功
            that.smsBtnDisabled = true;
            that.smsBtnText = '60秒后重新获取';
            let n = 60;
            let timer = setInterval(function(){
              that.smsBtnText = (n--) + '秒后重新获取';
              if(n==0){
                that.smsBtnDisabled = false;
                that.smsBtnText = '获取验证码';
                clearInterval(timer);
              }
            },1000);
          }
        })
      }
    },
    changePwd(){
      //注册
       let that = this;
       if(this.phone == ""){
        this.$toast('请填写手机号');
      }else if(this.smsCode == ""){
        this.$toast('请填写验证码');
      }else if(this.password == ""){
        this.$toast('请输入密码');
      }else{
        this.$api.post(that.jumuc.user.changePwd,
          { 
            'mobile':that.phone,
            'password':that.password,
            'vcode':that.smsCode,
          },
          successRes=>{
            if(successRes.success){
              //注册成功
                that.$toast({
                  message:successRes.msg,
                  duration:3000,
                  onClose:function(){
                    that.back();
                  }
                });
            }else{
              that.$toast('密码修改失败')
            }
          })
      }
    }
  },
};
</script>
<style lang="less" scoped>
@bule-thame: #3C6EEB;

.jump-login {
  &-logo {
    padding: 25px 0;
    text-align: center;
    img {
      width: 95px;
    }
  }
  &-body {
    .van-hairline--top-bottom::after {
      border-top: none;
    }
    &-agree{
      .van-cell__title{
        line-height: 35px;
        color: @bule-thame
      }
    }
    .smsBtn {
      background-color: @bule-thame;
      border-radius: 5px;
    }
    &-foo {
      padding: 10px 15px;
      font-size: 14px;

      button {
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
      p {
        color: @bule-thame;
      }
      &-title {
        text-align: center;
        padding: 25px 0;
      }
      h5 {
        display: inline;
        font-size: 14px;
        position: relative;
        color: #ccc;
      }

      h5:before {
        width: 90px;
        height: 1px;
        content: "";
        position: absolute;
        top: 50%;
        left: -100px;
        background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
        background: -moz-linear-gradient(left, #eeeeee, #dddddd);
        background: linear-gradient(left, #eeeeee, #dddddd);
      }

      h5:after {
        width: 90px;
        height: 1px;
        content: "";
        position: absolute;
        top: 50%;
        right: -100px;
        background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
        background: -moz-linear-gradient(left, #eeeeee, #dddddd);
        background: linear-gradient(left, #eeeeee, #dddddd);
      }
      &-btn a{
        font-size: 16px;
        color: @bule-thame;
      }
      &-treaty{
        padding-top: 10px;
        line-height: 30px;
        vertical-align: middle;
        i{
          vertical-align: middle;
        }
        a{
          margin-left:5px;
          color: @bule-thame; 
        }
      }
    }
    &-icon {
      padding-top: 20px;
      i {
        font-size: 48px;
        color: @bule-thame;
      }
    }
  }
}
</style>
